import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[1];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[2].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[2].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[0].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[0].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <div className="row align-items-center mt-5 mb-2">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Escribe si estás de acuerdo o en desacuerdo con las siguientes
              afirmaciones y por qué. Ten en cuenta la imagen anterior.
            </li>
          </ul>
          <p className="text-sm">
            En la escuela solo debe enseñarse castellano. El quechua debe usarse
            solo con la familia.
          </p>
          <textarea rows={"4"} className="form-control w-100 mb-4" />

          <p className="text-sm">
            Los policías en la comisaría necesitan hablar quechua para poder
            atender a todos los vecinos.
          </p>
          <textarea rows={"4"} className="form-control w-100 mb-3" />

          <p className="text-sm">
            Si la doctora habla quechua, mejorará su atención a los pacientes.
          </p>
          <textarea rows={"6"} className="form-control w-100 mb-3" />

          <p className="text-sm">
            En la biblioteca solo debe haber libros en castellano porque casi
            nadie lee libros en quechua.
          </p>
          <textarea rows={"6"} className="form-control w-100 mb-3" />
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-10">
          <ul>
            <li>
              Escoge alguna de las afirmaciones de la actividad anterior con la
              que estás en desacuerdo y escribe aquí por qué lo estás.
            </li>
          </ul>
          <div className="px-3">
            <textarea className="form-control" rows="6" />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la indicación: Escribe si estás de acuerdo o en desacuerdo con
            las siguientes afirmaciones. Ten en cuenta la imagen anterior. Ahora
            pida al niño o a la niña que lea en voz alta cada una de las
            afirmaciones. Dé un tiempo para que trabajen. Retome las respuestas.
            Puede elaborar un cuadro para apuntar si están o no de acuerdo con
            las afirmaciones.
          </li>
          <li>
            Lea la indicación: Escoge alguna de las afirmaciones de la actividad
            anterior con la que estás en desacuerdo y escribe aquí por qué lo
            estás. Dé un tiempo para que trabajen y luego retome algunas
            respuestas. Cierre la actividad señalando que es importante que en
            todos los lugares se hablen los dos idiomas, tanto quechua como
            castellano. Ello no solo le brinda iguales oportunidades de acceso a
            información y servicios a toda la población, sin excluir a nadie,
            sino que colabora a que, con el uso de las lenguas en diferentes
            contextos, se mantenga viva.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
